import { observable, action, autorun } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import userSharedFormsValidator from '../../services/validations/userSharedFormsValidator';
import commonValidators from '../../services/validations/commonValidators';


class SAMLValidatorStore {

    @observable form1Errors = [];

    // indicators
    @setter @observable certificateFilenameValid;
    @setter @observable issuerValid;
    @setter @observable teamMappingAttributeValid;
    @setter @observable nameValid;
    @setter @observable loginUrlValid;
    @setter @observable logoutUrlValid;
    @setter @observable errorUrlValid;
    @setter @observable defaultTeamIdValid;

    // messages
    @setter @observable certificateFileValidationMessage;
    @setter @observable issuerValidationMessage;
    @setter @observable nameValidationMessage;
    @setter @observable loginUrlValidationMessage;
    @setter @observable logoutUrlValidationMessage;
    @setter @observable errorUrlValidationMessage;
    @setter @observable defaultTeamIdValidationMessage;
    @setter @observable teamMappingAttributeValidationMessage;


    isValid = validation => (validation.errorCount === 0 ? true : false);

    @action validateCertificateFilename = name => {

        const validation = userSharedFormsValidator.validateGenericRequiredField(name);

        this.certificateFileValidationMessage = validation.errors.first('field');

        this.form1Errors.push(validation.errorCount);

        this.certificateFilenameValid = this.isValid(validation);
    }

    @action validateIssuer = name => {

        const validation = userSharedFormsValidator.validateGenericRequiredField(name);

        this.issuerValidationMessage = validation.errors.first('field');

        this.form1Errors.push(validation.errorCount);

        this.issuerValid = this.isValid(validation);
    }

    @action validateTeamMappingAttribute = name  => {

        const validation = userSharedFormsValidator.validateGenericRequiredField(name);

        this.teamMappingAttributeValidationMessage = validation.errors.first('field');

        this.form1Errors.push(validation.errorCount);

        this.teamMappingAttributeValid = this.isValid(validation);
    }

    @action validateName = name => {

        const validation = userSharedFormsValidator.validateGenericRequiredField(name);

        this.nameValidationMessage = validation.errors.first('field');

        this.form1Errors.push(validation.errorCount);

        this.nameValid = this.isValid(validation);
    }

    @action validateLoginUrl = name => {

        let validation = userSharedFormsValidator.validateGenericRequiredField(name);

        if (validation.errorCount < 1) {
            
            validation = commonValidators.validateUrl(name);
            this.loginUrlValidationMessage = validation.errors.first('url');
        }
        else {
            
            this.loginUrlValidationMessage = validation.errors.first('field');
        }

        this.form1Errors.push(validation.errorCount);

        this.loginUrlValid = this.isValid(validation);
    }

    @action validateLogoutUrl = url => {

        const validation = commonValidators.validateUrl(url);

        this.logoutUrlValidationMessage = validation.errors.first('url');

        this.form1Errors.push(validation.errorCount);

        this.logoutUrlValid = this.isValid(validation);
    }

    @action validateErrorUrl = url => {

        const validation = commonValidators.validateUrl(url);

        this.errorUrlValidationMessage = validation.errors.first('url');

        this.form1Errors.push(validation.errorCount);

        this.errorUrlValid = this.isValid(validation);
    }

    @action validateDefaultTeamId = name => {

        const validation = userSharedFormsValidator.validateGenericRequiredField(name);

        this.defaultTeamIdValidationMessage = validation.errors.first('field');

        this.form1Errors.push(validation.errorCount);

        this.defaultTeamIdValid = this.isValid(validation);
    }

    @action resetValidations = _ => {

        this.certificateFilenameValid = false;
        this.issuerValid = false;
        this.teamMappingAttributeValid = false;
        this.nameValid = false;
        this.loginUrlValid = false;
        this.logoutUrlValid = false;
        this.errorUrlValid= false;
        this.defaultTeamIdValid = false;

        this.certificateFileValidationMessage = '';
        this.issuerValidationMessage = '';
        this.nameValidationMessage = '';
        this.loginUrlValidationMessage = ''; 
        this.logoutUrlValidationMessage = ''; 
        this.errorUrlValidationMessage = ''; 
        this.defaultTeamIdValidationMessage = '';
        this.teamMappingAttributeValidationMessage = '';
    }

    validateForm = ({
        certificateFilename,
        issuer,
        name,
        loginUrl,
        logoutUrl,
        errorUrl,
        defaultTeamId,
        isManualManagement,
        mapSamlIdpAttributes,
        teamMappingAttribute
    }) => {
        this.form1Errors = [];
        
        this.validateCertificateFilename(certificateFilename);
        this.validateIssuer(issuer);
        this.validateName(name);
        this.validateLoginUrl(loginUrl);

        isManualManagement === true || isManualManagement === 'true' ?
            this.validateDefaultTeamId(defaultTeamId) : 0;

        mapSamlIdpAttributes === true || mapSamlIdpAttributes === 'true' ?
            this.validateTeamMappingAttribute(teamMappingAttribute) : 0;

        logoutUrl ? 
            this.validateLogoutUrl(logoutUrl) : 0;

        errorUrl ? 
            this.validateErrorUrl(errorUrl) : 0;
        
        return !this.form1Errors.includes(1);
    }
}

export default new SAMLValidatorStore();


// WEBPACK FOOTER //
// ./src/stores/saml/validator.js